import React, { useState, useEffect } from 'react';
import { makeStyles, Typography } from '@material-ui/core';

const REACT_APP_TILE_URL = 'https://tiles.mobilecoveragemap.com';

const formatDate = (date) =>
  `${twoChars(date.getDate().toString())}/${twoChars(
    (date.getMonth() + 1).toString()
  )}/${date.getFullYear()}`;

const twoChars = (str) => (str.length === 1 ? '0' + str : str);

const useStyles = makeStyles(() => ({
  updatedAt: {
    fontSize: 10,
    // fontFamily: 'Monospace,sans-serif',
  },
}));

const UpdatedAt = () => {
  const classes = useStyles();
  const [updatedAt, setUpdatedAt] = useState(null);
  useEffect(() => {
    fetch(`${REACT_APP_TILE_URL}/infos.json`)
      .then((res) => res.json())
      .then((data) => {
        if (data.dialCover !== undefined) {
          const date = formatDate(new Date(data.dialCover.updatedAt));
          setUpdatedAt(date);
        }
      })
      .catch((error) => console.log({ error }));
  }, []);
  return (
    <>
      {updatedAt && (
        <Typography className={classes.updatedAt}>
          Dernière mise à jour le {updatedAt}
        </Typography>
      )}
    </>
  );
};

export default UpdatedAt;
